/**
 * 统一商品数量+单位格式化（订单快照单位，非实时商品单位）
 *
 * 规则：
 *   基础显示：10条
 *   整包装时追加辅助：10条（1捆）
 *   未满包装：5条（不显示辅助包装）
 *
 * @param {Number} quantity - 数量
 * @param {String} unit - 基础单位（条/个/箱），来自 order_items 快照
 * @param {String} packUnit - 辅助包装单位（捆/包/托）
 * @param {Number} packQuantity - 换算数量（1捆=10条）
 * @returns {String} 格式化文本
 */
export function formatQty (quantity, unit, packUnit, packQuantity) {
  const u = unit || '个'
  const qty = parseInt(quantity, 10) || 0
  let text = `${qty}${u}`
  // 仅满足整包装条件时显示辅助包装
  if (packUnit && packQuantity > 1 && qty >= packQuantity && qty % packQuantity === 0) {
    const packs = qty / packQuantity
    text += `（${packs}${packUnit}）`
  }
  return text
}

/**
 * 从订单商品对象提取单位信息并格式化（兼容 order_items 快照字段）
 * @param {Object} item - order_items 行（含 quantity/unit/pack_unit/pack_quantity）
 * @returns {String}
 */
export function formatItemQty (item) {
  if (!item) return ''
  return formatQty(item.quantity, item.unit, item.pack_unit, item.pack_quantity)
}
